var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-drawer',{attrs:{"visible":_vm.drawer,"direction":"rtl","destroy-on-close":"","append-to-body":true,"size":"860px"},on:{"update:visible":function($event){_vm.drawer=$event}}},[_c('iframe',{attrs:{"src":_vm.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }